module.exports = __webpack_public_path__ + "img/focaccia_dough.1e9a7a6d.jpg";